<template>
    <div class='page_content'>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="开票申请" name="first">
                <div class="page_content_top" style="margin-top: 5px;">
                    <v-button style="position: relative;" :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo('first')" @openFormDesign="openFormDesign">
                        <template slot="buttonList">
                            <div class="div_button">
                                <el-checkbox v-model="puBank" :true-label="1" :false-label="0">购方银行信息</el-checkbox>
                                <el-checkbox v-model="suBank" :true-label="1" :false-label="0">销方银行信息</el-checkbox>
                                <el-checkbox v-model="batchInfo" :true-label="1" :false-label="0">是否拼接批号信息到备注</el-checkbox>
                                <el-checkbox v-model="taxSplitType" :true-label="1" :false-label="0">是否拆分税率</el-checkbox>
                                <el-checkbox v-model="isRemark" :true-label="1" :false-label="0">是否带入销售备注</el-checkbox>
                            </div>
                            <el-tag class="tag" style="margin-left: 30px;" size="small" type="danger">合计金额：{{ totalMoney }}</el-tag>
                        </template>
                    </v-button>
                    <div class="page_content_top_line">
                        <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
                    </div>
                </div>
                <div class="page_content_center">
                    <u-table v-if="dataList" :row-height="rowHeight" ref="hzTable" use-virtual size="mini" :data="returnData.list" @select="(selection, row)=>{selectChange(selection, row,'hz')}"
                        @select-all="(selection)=>{selectChangeAll(selection,'hz')}" :height="(tableHeight/2)+50" border style="width: 100%" highlight-current-row>
                        <u-table-column type="selection" width="55" fixed="left"></u-table-column>
                        <template v-for="(tableValye,tableKey) in dataList">
                            <u-table-column align="center" v-if="tableValye.isShow==1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'url'">
                                        <span class="copy" :data-clipboard-text="scope.row[tableValye.entityField]" @click="totiao(tableValye.entityField,scope.row.index)"
                                            :id="`${tableValye.entityField}${scope.row.index}`">{{scope.row[tableValye.entityField]}}</span>
                                    </span>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                    </span>
                                    <el-select v-else-if="tableValye.entityField=='pushMethod'" class="input" v-model="scope.row[tableValye.entityField]" placeholder="请选择" @change="pushMethodChange(scope.$index,tableValye.entityField)">
                                        <el-option v-for="item in JSON.parse(tableValye.formatterContent)" :key="item.value" :label="item.key" :value="item.value"></el-option>
                                    </el-select>
                                    <el-input v-else-if="tableValye.entityField=='pushPhone'&&(scope.row.pushMethod==1||scope.row.pushMethod==3)" class="input" v-model.trim="scope.row[tableValye.entityField]" clearable></el-input>
                                    <el-input v-else-if="tableValye.entityField=='pushEmail'&&(scope.row.pushMethod==2||scope.row.pushMethod==3)" class="input" v-model.trim="scope.row[tableValye.entityField]" clearable></el-input>
                                    <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini" type="primary">
                                        {{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
                                    <span v-else>
                                        {{scope.row[tableValye.entityField]}}
                                    </span>
                                </template>
                            </u-table-column>
                        </template>
                    </u-table>
                    <div class="page_content_bottom">
                        <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                    </div>
                    <u-table @select="(selection, row)=>{selectChange(selection, row,'mx')}" @select-all="(selection)=>{selectChangeAll(selection,'mx')}" @cell-dblclick="changeInput" :row-height="rowHeight" ref="mxTable" use-virtual
                        row-key="index" :data-changes-scroll-top="false" size="mini" :data="returnData.detailsList" :height="(tableHeight/2)-50" border style="width: 100%" highlight-current-row>
                        <u-table-column type="selection" width="55" fixed="left"></u-table-column>
                        <u-table-column type="index" width="55" fixed="left" label="序号" align="center"></u-table-column>
                        <template v-for="(tableValye,tableKey) in detailsList">
                            <u-table-column align="center" v-if="tableValye.isShow==1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'url'">
                                        <span class="copy" :data-clipboard-text="scope.row[tableValye.entityField]" @click="totiao(tableValye.entityField,scope.row.index)"
                                            :id="`${tableValye.entityField}${scope.row.index}`">{{scope.row[tableValye.entityField]}}</span>
                                    </span>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                    </span>
                                    <el-input v-else-if="tableValye.fieldType == 'input_number'" v-model="scope.row[tableValye.entityField]" type="number" @input="inputClick(scope.row.index,tableValye.entityField,1)"></el-input>
                                    <span v-else-if="tableValye.entityField=='zeroMark'">
                                        <el-select v-if="scope.row.outRate==0||scope.row.outRate==null||scope.row.outRate==''" filterable clearable class="input" v-model="scope.row[tableValye.entityField]" placeholder="请选择">
                                            <el-option v-for="item in tableValye.formatterContent" :key="item.value" :label="item.key" :value="item.value"></el-option>
                                        </el-select>
                                    </span>
                                    <el-select filterable clearable v-else-if="tableValye.entityField=='specialTax'" class="input" v-model="scope.row[tableValye.entityField]" placeholder="请选择">
                                        <el-option v-for="item in tableValye.formatterContent" :key="item.value" :label="item.key" :value="item.value"></el-option>
                                    </el-select>
                                    <el-select filterable clearable v-else-if="tableValye.entityField=='discountMark'" class="input" v-model="scope.row[tableValye.entityField]" placeholder="请选择">
                                        <el-option v-for="item in tableValye.formatterContent" :key="item.value" :label="item.key" :value="item.value"></el-option>
                                    </el-select>
                                    <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini" type="primary">
                                        {{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
                                    <el-input v-else-if="['bgpUnitmeasurement', 'bgmName', 'spec'].includes(tableValye.entityField) && scope.row[`edit_${tableValye.entityField}`]" v-model="scope.row[tableValye.entityField]"
                                        @blur="blurUpdate(scope.row, tableValye.entityField)"></el-input>
                                    <span v-else>
                                        {{scope.row[tableValye.entityField]}}
                                    </span>
                                </template>
                            </u-table-column>
                        </template>
                    </u-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="开票结果" name="second">
                <div class="page_content_top page_content_top_second" style="margin-top: 5px;">
                    <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo('second')" @openFormDesign="openFormDesign">
                        <template slot="buttonList">
                            <el-tag class="tag" style="margin-left: 30px;" size="small" type="danger">合计金额：{{ totalMoney1 }}</el-tag>
                        </template>
                    </v-button>
                    <div class="page_content_top_line">
                        <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
                    </div>
                </div>
                <div class="page_content_center">
                    <u-table v-if="dataList" @selection-change="handleSelectionChange" :row-height="rowHeight" ref="plTable" use-virtual size="mini" :data="returnData.list" :height="(tableHeight/2)+50" border style="width: 100%"
                        highlight-current-row>
                        <u-table-column type="selection" width="55" fixed="left"></u-table-column>
                        <template v-for="(tableValye,tableKey) in dataList">
                            <u-table-column align="center" v-if="tableValye.isShow==1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'datetime' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'url'">
                                        <span class="copy" :data-clipboard-text="scope.row[tableValye.entityField]" @click="totiao(tableValye.entityField,scope.row.index)"
                                            :id="`${tableValye.entityField}${scope.row.index}`">{{scope.row[tableValye.entityField]}}</span>
                                    </span>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                    </span>
                                    <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini" type="primary">
                                        {{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
                                    <span v-else>
                                        {{scope.row[tableValye.entityField]}}
                                    </span>
                                </template>
                            </u-table-column>
                        </template>
                    </u-table>
                    <div class="page_content_bottom">
                        <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                    </div>
                    <u-table :row-height="rowHeight" ref="plTable" use-virtual size="mini" :data="returnData.detailsList" :height="(tableHeight/2)-50" border style="width: 100%" highlight-current-row>
                        <template v-for="(tableValye,tableKey) in detailsList">
                            <u-table-column align="center" v-if="tableValye.isShow==1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'url'">
                                        <span class="copy" :data-clipboard-text="scope.row[tableValye.entityField]" @click="totiao(tableValye.entityField,scope.row.index)"
                                            :id="`${tableValye.entityField}${scope.row.index}`">{{scope.row[tableValye.entityField]}}</span>
                                    </span>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                    </span>
                                    <el-input v-else-if="tableValye.fieldType == 'input_number'" v-model="scope.row[tableValye.entityField]" type="number" @input="inputClick(scope.row.index,tableValye.entityField,2)"></el-input>
                                    <span v-else-if="tableValye.entityField=='zeroMark'">
                                        <el-select v-if="scope.row.outRate==0||scope.row.outRate==null||scope.row.outRate==''" filterable clearable class="input" v-model="scope.row[tableValye.entityField]" placeholder="请选择"
                                            @change="selectInputChange(1,scope.row.index)">
                                            <el-option v-for="item in tableValye.formatterContent" :key="item.value" :label="item.key" :value="item.value"></el-option>
                                        </el-select>
                                    </span>
                                    <el-select filterable clearable v-else-if="tableValye.entityField=='specialTax'" class="input" v-model="scope.row[tableValye.entityField]" placeholder="请选择" @change="selectInputChange(2,scope.row.index)">
                                        <el-option v-for="item in tableValye.formatterContent" :key="item.value" :label="item.key" :value="item.value"></el-option>
                                    </el-select>
                                    <el-select filterable clearable v-else-if="tableValye.entityField=='discountMark'" class="input" v-model="scope.row[tableValye.entityField]" placeholder="请选择"
                                        @change="selectInputChange(3,scope.row.index)">
                                        <el-option v-for="item in tableValye.formatterContent" :key="item.value" :label="item.key" :value="item.value"></el-option>
                                    </el-select>
                                    <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini" type="primary">
                                        {{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
                                    <span v-else>
                                        {{scope.row[tableValye.entityField]}}
                                    </span>
                                </template>
                            </u-table-column>
                        </template>
                    </u-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog title="获取验证码" :visible.sync="loginShow" width="400px" :modal-append-to-body='true' :append-to-body="true">
            <el-form :model="formInline" class="demo-form-inline loginShow" label-width="60px">
                <el-form-item label="验证码">
                    <el-input v-model="formInline.sendCode" placeholder="请输入验证码">
                        <template slot="append">
                            <el-button class="btn" type="primary" @click="sendCodeClick" :disabled="codeNum!=60">{{codeTitle}}</el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="sendCodeSub()">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="二维码" :visible.sync="qrCodeShow" width="250px" :modal-append-to-body='true' :append-to-body="true">
            <div class="qrcode_div">
                <p class="title">请打开电子税务局APP,扫描二维码</p>
                <div id="qrcode" ref="qrCodeUrl"></div>
            </div>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="invoiceShow" width="300px" :modal-append-to-body='true' :append-to-body="true">
            <el-form :model="invoiceObj" ref="ruleForm" label-width="80px" class="demo-ruleForm" :inline-message="false" :show-message="false">
                <el-form-item v-if="invoiceObj.actionType != 'returnRedChong'" label="发票类型" prop="billType" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-radio-group v-model="invoiceObj.billType" size="medium">
                        <el-radio-button label="普票">普票</el-radio-button>
                        <el-radio-button label="专票">专票</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="invoiceObj.actionType != 'returnRedChong'" label="是否合并" prop="type" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-radio-group v-model="invoiceObj.type" size="medium">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="invoiceObj.actionType == 'returnRedChong'" label="红冲原因" prop="rushReason" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-select class="input" v-model="invoiceObj.rushReason" placeholder="请选择">
                        <el-option label="开票有误" value="01"></el-option>
                        <el-option label="销货退回" value="02"></el-option>
                        <el-option label="服务中止" value="03"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="submitForm('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="redRusShow" width="80%" :modal-append-to-body='true' :append-to-body="true">
            <makeInvoiceAction v-if="redRusShow" :actionData="actionData" @drawerCancel="drawerCancel"></makeInvoiceAction>
        </el-dialog>
        <el-dialog title="修改备注" :visible.sync="remarkShow" width="400px" :modal-append-to-body='true' :append-to-body="true">
            <el-form label-width="80px" class="demo-ruleForm" :inline-message="false" :show-message="false">
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="备注" v-model="remark"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="submitRemark('ruleForm')">修 改</el-button>
            </span>
        </el-dialog>
        <el-dialog title="推送" :visible.sync="pushShow" width="500px" :modal-append-to-body='true' :append-to-body="true">
            <el-form :model="pushObj" label-width="100px" ref="pushForm" class="demo-ruleForm" :inline-message="false" :show-message="false">
                <el-form-item label="推送方式" prop="pushMethod" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-radio-group v-model="pushObj.pushMethod" size="medium" @input="inputChange">
                        <el-radio-button :label="0">不推送</el-radio-button>
                        <el-radio-button :label="1">短信</el-radio-button>
                        <el-radio-button :label="2">邮箱</el-radio-button>
                        <!-- <el-radio-button :label="3">全部</el-radio-button> -->
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="pushObj.pushMethod==1||pushObj.pushMethod==3" label="推送手机号" prop="pushPhone" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input type="text" placeholder="推送手机号" v-model="pushObj.pushPhone" clearable> </el-input>
                </el-form-item>
                <el-form-item v-if="pushObj.pushMethod==2||pushObj.pushMethod==3" label="推送邮箱" prop="pushEmail" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input type="text" placeholder="推送邮箱" v-model="pushObj.pushEmail" clearable> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="submitPush('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import indexJS from './makeInvoiceQuery';
import NP from "number-precision";
import Clipboard from 'clipboard';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import makeInvoiceAction from "@/components/makeInvoiceAction.vue";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
export default {
    components: { makeInvoiceAction },
    name: "makeInvoiceQuery",
    data() {
        return {
            imgUrl: window.global_config.BASE_IMG_URL,
            activeName: "first",
            tableHeight: 700,
            rowHeight: 35,
            searchList: indexJS.searchList,
            pageShowData: {},
            dataList: indexJS.dataList,
            detailsList: indexJS.dataDetailsList,
            getRequestData: {},
            buttonList: indexJS.buttonList,
            returnData: {
                list: [],
                detailsList: [],
                total: 0,
            },
            selectData: [],
            JG_selectData: [],
            selectDetailsData: [],//明细勾选
            //-----------
            puBank: 0,//购方银行信息
            suBank: 0,//销方银行信息
            batchInfo: 0,//是否拼接批号信息到备注
            taxSplitType: 1,//是否拆分税率
            //---------------
            seTitle: "",
            DialogVisible: false,
            seId: "",
            setField: "",
            setType: "",
            seWidth: "0",
            parentSearchData: {},
            //---------------
            loginShow: false,
            codeNum: 60,
            codeTitle: "获取验证码",
            formInline: {
                sendCode: ""
            },
            timers: null,
            qrCodeShow: false,
            qrCode: "",//二维码
            //------------
            invoiceShow: false,//是否开票
            invoiceObj: {
                type: 1,
                billType: "普票",
                rushReason: "",
            },
            //--------//下载发票
            pdfUrl: "",
            isDownloading: false,
            imgList: [],
            //----------------//红冲发票
            redRusShow: false,
            actionData: {},
            //--------------//修改备注
            remarkShow: false,
            isRemark: 0,
            remark: "",
            //--------------再次推送
            pushShow: false,
            pushObj: {
                ticketNum: "",
                billType: "",
                pushMethod: 0,
                pushPhone: "",
                pushEmail: "",
            },
            totalMoney: 0,
            totalMoney1: 0,
        }
    },
    watch: {
        qrCodeShow() {
            clearTimeout(this.timers)
        },
        loginShow() {
            if (!this.loginShow) {
                this.formInline.sendCode = ""
                this.codeNum = 60
                this.codeTitle = "获取验证码"
            }
        },
        selectDetailsData: {
            handler: function (newValue) {
                // 先用 Map 提高 selectData 查找效率
                const selectDataMap = new Map(this.selectData.map(item => [item.dasmId, item]));
                // 遍历 returnData.list，更新金额，并同步 selectData 的引用内容
                this.returnData.list.forEach(item => {
                    if (selectDataMap.has(item.dasmId)) {
                        // 重置金额
                        item.totalntaxMoney = 0;
                        item.oldMoney = 0;
                        item.taxMoney = 0;
                        // 计算明细
                        const arrDetails = newValue.filter(val => val.dasmId == item.dasmId);
                        arrDetails.forEach(item1 => {
                            item.totalntaxMoney = this.$common.getDecimalInfo(3, NP.plus(item.totalntaxMoney, item1.money));
                            item.oldMoney = this.$common.getDecimalInfo(3, NP.plus(item.oldMoney, item1.psmoney));
                            item.taxMoney = this.$common.getDecimalInfo(3, NP.plus(item.taxMoney, item1.taxAmount));
                        });
                        // 同步 selectData 的对象引用
                        selectDataMap.set(item.dasmId, item);
                    }
                });
                // 更新 selectData 为最新对象引用
                this.selectData = Array.from(selectDataMap.values());
            },
            deep: true,
        },
        "returnData.detailsList": {
            handler: function (newValue) {
                this.selectDetailsData.forEach(item => {
                    var arr = newValue.filter(val => val.dasdId == item.dasdId)
                    if (arr.length > 0) {
                        this.$set(item, 'ddinCount', arr[0].ddinCount)
                        this.$set(item, 'money', arr[0].money)
                        this.$set(item, 'psmoney', arr[0].psmoney)
                        this.$set(item, 'taxAmount', arr[0].taxAmount)
                    }
                })
            },
            deep: true,
        },
        "selectData": {
            handler: function (newValue) {
                this.totalMoney = 0
                newValue.forEach(item => {
                    this.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this.totalMoney, item.oldMoney))
                })

            },
            deep: true,
        },
        "JG_selectData": {
            handler: function (newValue) {
                this.totalMoney1 = 0
                newValue.forEach(item => {
                    this.totalMoney1 = this.$common.getDecimalInfo(3, NP.plus(this.totalMoney1, item.poolPsmoney))
                })
            },
            deep: true,
        },
    },
    methods: {
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            console.log(this.pageShowData);

            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 双击编辑
        changeInput(row, column) {
            // 只有当字段是 bgpUnitmeasurement、bgmName、spec 时才允许编辑
            if (['bgpUnitmeasurement', 'bgmName', 'spec'].includes(column.property)) {
                const table = this.$refs.mxTable;
                const singleTable = table && table.$refs.singleTable;
                const scrollTop = singleTable ? singleTable.scrollTop : 0;
                const scrollLeft = singleTable ? singleTable.scrollLeft : 0;
                // 关闭其他字段的编辑状态
                ['bgpUnitmeasurement', 'bgmName', 'spec'].forEach(field => {
                    if (field !== column.property) {
                        this.$set(row, `edit_${field}`, false);
                    }
                });
                // 开启当前字段的编辑状态
                this.$set(row, `edit_${column.property}`, true);
                // 触发虚拟表格局部刷新，避免滚动条回到顶部
                this.returnData.detailsList.splice(1, 0);
                this.$nextTick(() => {
                    if (table && table.pagingScrollTopLeft) {
                        table.pagingScrollTopLeft(scrollTop, scrollLeft);
                    }
                    // 在当前明细表格内查找输入框并设置焦点
                    const tableEl = table && table.$el;
                    const inputElements = tableEl ? tableEl.querySelectorAll('.el-input__inner') : [];
                    if (inputElements.length > 0) {
                        const inputElement = inputElements[inputElements.length - 1];
                        inputElement && inputElement.focus();
                    }
                });
            }
        },
        // 失去焦点时保存修改
        blurUpdate(row, field) {
            const table = this.$refs.mxTable;
            const singleTable = table && table.$refs.singleTable;
            const scrollTop = singleTable ? singleTable.scrollTop : 0;
            const scrollLeft = singleTable ? singleTable.scrollLeft : 0;
            // 关闭当前字段的编辑状态
            this.$set(row, `edit_${field}`, false);

            // 如果当前行有 bgmId，且字段是我们关心的三个字段之一
            if (row.bgmId && ['bgpUnitmeasurement', 'bgmName', 'spec'].includes(field)) {
                const newValue = row[field];
                // 遍历所有数据，更新 bgmId 相同的项
                this.returnData.detailsList.forEach(item => {
                    if (item.bgmId === row.bgmId && item !== row) {
                        this.$set(item, field, newValue);
                    }
                });
            }
            this.returnData.detailsList.splice(1, 0);
            this.$nextTick(() => {
                if (table && table.pagingScrollTopLeft) {
                    table.pagingScrollTopLeft(scrollTop, scrollLeft);
                }
            });
        },
        async selectInputChange(type, index) {
            const params = {
                discountMark: this.returnData.detailsList[index].discountMark || "",
                id: this.returnData.detailsList[index].id,
                specialTax: this.returnData.detailsList[index].specialTax || "",
                zeroMark: this.returnData.detailsList[index].zeroMark || "",
            }
            const res = await this.$http.updatePush(params)
            if (res.status == 200) {
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }
        },
        inputChange() {
            if (this.pushObj.pushMethod == 0) {
                this.pushObj.pushEmail = ""
                this.pushObj.pushPhone = ""
            } else if (this.pushObj.pushMethod == 1) {
                this.pushObj.pushEmail = ""
            } else if (this.pushObj.pushMethod == 2) {
                this.pushObj.pushPhone = ""
            }
        },
        handleSelectionChange(val) {
            this.JG_selectData = val
            if (this.JG_selectData.length > 0) {
                this.getDataDetails()
            }
        },
        drawerCancel(type) {
            this.redRusShow = false
            if (type) {
                this.getDataList()
            }
        },
        totiao(type, index) {
            console.log(type, index);

            let clipboard = new Clipboard(`#${type}${index}`);
            let that = this;
            clipboard.on("success", function (e) {
                console.log(type, index);
                that.$message.success("复制成功");
                clipboard.destroy()
            });
            clipboard.on("error", function (e) {
                that.$message.error("复制失败");
                clipboard.destroy()
            })
        },
        inputClick(index, type, val) {
            const detail = this.returnData.detailsList[index];
            // 数量校验
            const invQty = Number(detail.invoicableQuantity);
            let ddinCount = Number(detail.ddinCount);
            if (invQty < 0) {
                if (ddinCount > 0 || Math.abs(ddinCount) > Math.abs(invQty)) {
                    ddinCount = invQty;
                }
            } else {
                if (ddinCount < 0 || Math.abs(ddinCount) > Math.abs(invQty)) {
                    ddinCount = invQty;
                }
            }
            this.$set(detail, 'ddinCount', ddinCount);
            this.$set(detail, 'psmoney', this.$common.getDecimalInfo(3, NP.times(ddinCount || 0, detail.psprice)));
            var money = detail.psmoney == 0 || detail.psmoney == "" ? 0 : NP.divide(detail.psmoney, NP.plus(NP.divide(detail.outRate, 100), 1))
            // 金额联动
            this.$set(detail, 'money', this.$common.getDecimalInfo(3, money));
            this.$set(detail, 'taxAmount', this.$common.getDecimalInfo(3, NP.minus(detail.psmoney, detail.money)));
            if (val === 1 && type === 'ddinCount') {
                // 取消勾选
                if (ddinCount === 0) {
                    this.$refs.mxTable.toggleRowSelection([{ row: detail, selected: false }]);
                    // 移除明细勾选
                    const mxIndex = this.selectDetailsData.findIndex(item => item.dasdId === detail.dasdId);
                    if (mxIndex !== -1) {
                        this.selectDetailsData.splice(mxIndex, 1);
                        // 如果该主单下所有明细都未勾选，则取消主单勾选
                        const hasOther = this.selectDetailsData.some(item => item.dasmId === detail.dasmId);
                        if (!hasOther) {
                            const hzIndex = this.selectData.findIndex(item => item.dasmId === detail.dasmId);
                            if (hzIndex !== -1) {
                                const arr = this.selectData.splice(hzIndex, 1);
                                this.$refs.hzTable.toggleRowSelection([{ row: arr[0], selected: false }]);
                            }
                        }
                    }
                } else {
                    // 勾选明细
                    this.$refs.mxTable.toggleRowSelection([{ row: detail, selected: true }]);
                    if (!this.selectDetailsData.some(item => item.dasdId === detail.dasdId)) {
                        this.selectDetailsData.push(detail);
                    }
                    // 勾选主单
                    const arr1 = this.returnData.list.filter(item => item.dasmId === detail.dasmId);
                    if (arr1.length > 0 && !this.selectData.some(item => item.dasmId === arr1[0].dasmId)) {
                        this.selectData.push(arr1[0]);
                        this.$refs.hzTable.toggleRowSelection([{ row: arr1[0], selected: true }]);
                    }
                }
            }
        },
        handleClick() {
            var obj = this.$common.getSearchData(this.searchList, 'page', "rows", 30)
            for (const key in obj) {
                this.$set(this.getRequestData, key, obj[key])
            }
            this.getRequestData.page = 1
            this.returnData.list = []
            this.init()
            if (this.activeName == 'first') {
                this.buttonList = indexJS.buttonList
                this.searchList = indexJS.searchList
                if (this.pageShowData) {
                    this.dataList = this.pageShowData.jurTableVo.jurconfigtable
                } else {
                    this.dataList = indexJS.dataList
                }
                this.detailsList = indexJS.dataDetailsList
            } else if (this.activeName == 'second') {
                this.buttonList = indexJS.buttonListJG
                this.searchList = indexJS.searchListJG
                if (this.pageShowData) {
                    this.dataList = this.pageShowData.jurFormVoList[0].jurconfigform
                } else {
                    this.dataList = indexJS.dataListJG
                }
                this.detailsList = indexJS.dataDetailsListJG
            }
            this.getDataList()
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        openSearch(val) {
            this.setType = val.type
            this.seId = val.sId
            this.setField = val.sField
            this.parentSearchData[this.setType] = this.getRequestData[this.setType]
            if (this.setType == 'salesName') {
                this.parentSearchData.opmSalesperson = 1
            }
            this.DialogVisible = true

        },
        changeInputModel(val) {
            if (val) {
                if (this.setType == 'salesName') {
                    this.getRequestData.salesName = val.opmName
                    this.getRequestData.salesId = val.opmId
                } else {
                    this.paramValue(val)
                }
            }
            this.DialogVisible = false
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.setField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        async getPageInfo(val) {
            this.activeName = val ? val : 'first'
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                if (this.activeName == 'first') {
                    this.buttonList = indexJS.buttonList
                    this.searchList = indexJS.searchList
                    if (this.pageShowData) {
                        if(this.pageShowData.jurTableVo && this.pageShowData.jurTableVo.jurconfigtable && this.pageShowData.jurTableVo.jurconfigtable.length > 0){
                            this.dataList = this.pageShowData.jurTableVo.jurconfigtable
                        } else {
                            this.dataList = indexJS.dataList
                        }
                    } else {
                        this.dataList = indexJS.dataList
                    }
                    this.detailsList = indexJS.dataDetailsList
                } else if (this.activeName == 'second') {
                    this.buttonList = indexJS.buttonListJG
                    this.searchList = indexJS.searchListJG
                    if (this.pageShowData) {
                        if(this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList[0].jurconfigform && this.pageShowData.jurFormVoList[0].jurconfigform.length > 0){
                            this.dataList = this.pageShowData.jurFormVoList[0].jurconfigform
                        } else {
                            this.dataList = indexJS.dataListJG
                        }
                    } else {
                        this.dataList = indexJS.dataListJG
                    }
                    this.detailsList = indexJS.dataDetailsListJG
                }
                var obj = this.$common.getSearchData(this.searchList, 'page', "rows", 30)
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getRequestData.page = 1
                this.init()
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 动作集合
        async actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    if (this.selectData.length == 0) {
                        return this.$message.error("请勾选数据开票")
                    }
                    this.invoiceObj.rushReason = ""
                    this.faceAuthState('addApply')
                    break;
                case 9:
                    if (this.selectData.length == 0) {
                        return this.$message.error("请勾选数据")
                    }
                    const hasInvalidType = this.selectData.some(item => item.businessType !== "销售退货");
                    if (hasInvalidType) {
                        return this.$message.error("该状态不可退货红冲，请只勾选销售退货状态数据");
                    }
                    this.invoiceObj.rushReason = ""
                    this.faceAuthState('returnRedChong')
                    break;
                case 10:
                    if (this.selectData.length == 0) {
                        return this.$message.error("请勾选数据")
                    }
                    const hasInvalidType2 = this.selectData.some(item => item.businessType !== "销售退补");
                    if (hasInvalidType2) {
                        return this.$message.error("该状态不可退补红冲，请只勾选销售退补状态数据");
                    }
                    this.invoiceObj.rushReason = ""
                    this.faceAuthState('returnRrRed')
                    break;
                case 1:
                    this.loginShow = true
                    break;
                case 2:
                    this.qRCodeChange()
                    break;
                case 3://红冲发票
                    if (this.returnData.list.length == 0) {
                        return this.$message.error("暂无数据")
                    }
                    if (this.JG_selectData.length != 1) {
                        return this.$message.error("请先勾选一条数据")
                    }
                    var dataInfo = this.JG_selectData[0]
                    if (dataInfo.state != 2 && dataInfo.state != 3) {
                        return this.$message.error("该状态不可红冲")
                    }
                    this.actionData = {
                        hz: dataInfo,
                        mx: this.returnData.detailsList
                    }
                    this.redRusShow = true
                    break;
                case 7://打印
                    if (this.returnData.list.length == 0) {
                        return this.$message.error("暂无数据")
                    }
                    if (this.JG_selectData.length == 0) {
                        return this.$message.error("请先勾选数据")
                    }
                    this.pdfUrl = this.JG_selectData
                        .filter(item => item.pdfPath)
                        .map(item => ({
                            url: `${this.imgUrl}/${item.pdfPath}`,
                        }));
                    const res = await this.printSequentially()
                    this.print(res)
                    break;
                case 5://回退
                    this.rollback()
                    break;
                case 6://修改备注
                    var arr = this.selectData.filter(val => val.cmId = this.selectData[0].cmId)
                    if (arr.length != this.selectData.length) {
                        return this.$message.error("请勾选相同客户修改备注")
                    }
                    this.remark = this.selectData[0].remark
                    this.remarkShow = true
                    break;
                case 4://下载发票
                    if (this.returnData.list.length == 0) {
                        return this.$message.error("暂无数据")
                    }
                    if (this.JG_selectData.length == 0) {
                        return this.$message.error("请先勾选数据")
                    }
                    // `${this.imgUrl}/${this.JG_selectData[0].pdfPath}`
                    this.pdfUrl = this.JG_selectData.map(item => {
                        return {
                            url: `${this.imgUrl}/${item.pdfPath}`,
                            name: item.pdfPath.split("/")[2].split(".")[0]
                        }
                    })
                    this.downloadSequentially()
                    break;
                case 8://再次推送
                    if (this.returnData.list.length == 0) {
                        return this.$message.error("暂无数据")
                    }
                    if (this.JG_selectData.length != 1) {
                        return this.$message.error("请先勾选数据")
                    }
                    var dataInfo = this.JG_selectData[0];
                    if (dataInfo.state < 2) {
                        return this.$message.error("该状态不可再次推送")
                    }
                    for (const key in this.pushObj) {
                        if (
                            dataInfo.hasOwnProperty(key) &&
                            dataInfo[key] !== "" &&
                            dataInfo[key] !== null &&
                            dataInfo[key] !== undefined
                        ) {
                            this.pushObj[key] = dataInfo[key];
                        }
                    }
                    this.pushShow = true
                    break;
            }
        },
        // 使用PDF.js渲染PDF后打印，返回该PDF所有页的图片dataURL数组
        async printPDFWithPDFJS(pdfUrl) {
            // 加载PDF文档
            const loadingTask = pdfjsLib.getDocument(pdfUrl);
            const pdf = await loadingTask.promise;
            const pages = [];
            // 渲染每一页为图片
            for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                const page = await pdf.getPage(pageNum);

                // 设置渲染参数
                const viewport = page.getViewport({ scale: 2.5 });
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                // 渲染页面
                await page.render({
                    canvasContext: context,
                    viewport: viewport
                }).promise;
                pages.push(canvas.toDataURL());
            }
            return pages;
        },
        // 顺序打印所有PDF，把每个PDF的多页扁平合并成一个图片数组
        async printSequentially() {
            const list = []
            for (let i = 0; i < this.pdfUrl.length; i++) {
                const pages = await this.printPDFWithPDFJS(this.pdfUrl[i].url);
                for (const dataUrl of pages) {
                    list.push(dataUrl);
                }
            }
            return list
        },
        print(val) {
            if (!val || val.length === 0) {
                this.$message.error("没有可打印的PDF");
                return;
            }

            // 纸张尺寸定义 (宽度 x 高度，单位：毫米)
            const paperSizes = {
                'A3': { width: 297, height: 420 },
                'A4': { width: 210, height: 297 },
                'A5': { width: 148, height: 210 },
                'B4': { width: 250, height: 353 }, // B4(JIS)
                'B5': { width: 176, height: 250 }, // B5(JIS)
                'letter': { width: 216, height: 279 }, // 信纸
                'tabloid': { width: 279, height: 432 }, // Tabloid
                'legal': { width: 216, height: 356 }, // 法律专用纸
                'statement': { width: 140, height: 216 }, // Statement
                'executive': { width: 184, height: 267 } // Executive
            };

            // 构建所有图片的HTML内容
            let imgsHtml = "";
            for (let index = 0; index < val.length; index++) {
                imgsHtml += `
               <div class="print-page">
               <img src='${val[index]}' class="print-image" onerror="this.parentElement.innerHTML='<div style=color:red;text-align:center;margin-top:50px;>图片加载失败</div>'" />
               </div>
            `;
            }

            // 生成纸张尺寸的CSS规则
            let paperSizeCSS = '';
            // 纵向尺寸
            Object.entries(paperSizes).forEach(([size, dimensions]) => {
                paperSizeCSS += `
               @media print and (media-size: ${size}) {
               .print-page {
                  width: ${dimensions.width}mm;
                  height: ${dimensions.height}mm;
               }
               .print-image {
                  width: ${dimensions.width}mm;
                  height: ${dimensions.height}mm;
               }
               }
            `;
            });

            // 横向尺寸
            Object.entries(paperSizes).forEach(([size, dimensions]) => {
                paperSizeCSS += `
               @media print and (orientation: landscape) and (media-size: ${size}) {
               .print-page {
                  width: ${dimensions.height}mm;
                  height: ${dimensions.width}mm;
               }
               .print-image {
                  width: ${dimensions.height}mm;
                  height: ${dimensions.width}mm;
               }
               }
            `;
            });

            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
            <html>
            <head>
               <title>发票打印</title>
               <style>
               @media print {
                  @page {
                     margin: 0;
                  }
               }
               
               body {
                  margin: 0;
                  padding: 0;
               }
               
               .print-page {
                  page-break-after: always;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  overflow: hidden;
               }
               
               .print-page:last-child {
                  page-break-after: avoid;
               }
               
               .print-image {
                  object-fit: contain;
                  display: block;
                  max-width: 100%;
                  max-height: 100%;
               }
               
               /* 默认使用A4纸张 */
               .print-page {
                  width: 210mm;
                  height: 297mm;
               }
               .print-image {
                  width: 210mm;
                  height: 297mm;
               }
               
               /* 纵向支持 */
               @media print and (orientation: portrait) {
                  .print-page {
                     width: 210mm;
                     height: 297mm;
                  }
                  .print-image {
                     width: 210mm;
                     height: 297mm;
                  }
               }
               
               /* 横向支持 */
               @media print and (orientation: landscape) {
                  .print-page {
                     width: 297mm;
                     height: 210mm;
                  }
                  .print-image {
                     width: 297mm;
                     height: 210mm;
                  }
               }
               
               /* 各种纸张尺寸支持 */
               ${paperSizeCSS}
               </style>
            </head>
            <body>
               ${imgsHtml}
               <script>
               window.onload = function() { 
                  window.print(); 
                  window.close(); 
               }
               <\/script>
            </body>
            </html>
         `);
            printWindow.document.close();
        },
        // 顺序下载PDF文件（一个接一个），弹框选择保存路径
        async downloadSequentially() {
            if (this.isDownloading) {
                return;
            }
            if (!this.pdfUrl || !this.pdfUrl.length) {
                return;
            }
            this.isDownloading = true;
            try {
                // 支持目录选择：先选文件夹，再批量写入
                if (window.showDirectoryPicker) {
                    const dirHandle = await window.showDirectoryPicker({
                        mode: "readwrite",
                    });
                    for (let i = 0; i < this.pdfUrl.length; i++) {
                        await this.downloadPDFToDir(
                            this.pdfUrl[i].url,
                            `${this.pdfUrl[i].name}.pdf`,
                            dirHandle
                        );
                    }
                    this.$message.success("下载完成");
                    return;
                }
                // 支持另存为：逐个选择保存路径
                if (window.showSaveFilePicker) {
                    for (let i = 0; i < this.pdfUrl.length; i++) {
                        await this.downloadPDFWithPicker(
                            this.pdfUrl[i].url,
                            `${this.pdfUrl[i].name}.pdf`
                        );
                    }
                    this.$message.success("下载完成");
                    return;
                }
                // 不支持文件系统 API 时回退到默认下载
                for (let i = 0; i < this.pdfUrl.length; i++) {
                    await this.downloadPDF(this.pdfUrl[i].url, `${this.pdfUrl[i].name}.pdf`);
                    await new Promise((resolve) => setTimeout(resolve, 100));
                }
            } catch (error) {
                // 用户取消选择不提示错误
                if (error && (error.name === "AbortError" || error.name === "NotAllowedError")) {
                    return;
                }
                console.error("下载过程中出现错误:", error);
                this.$message.error("下载失败");
            } finally {
                this.isDownloading = false;
            }
        },
        // 下载到指定目录
        async downloadPDFToDir(url, filename, dirHandle) {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const blob = await response.blob();
            const fileHandle = await dirHandle.getFileHandle(filename, { create: true });
            const writable = await fileHandle.createWritable();
            await writable.write(blob);
            await writable.close();
        },
        // 弹框另存为
        async downloadPDFWithPicker(url, filename) {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const blob = await response.blob();
            const fileHandle = await window.showSaveFilePicker({
                suggestedName: filename,
                types: [
                    {
                        description: "PDF 文件",
                        accept: { "application/pdf": [".pdf"] },
                    },
                ],
            });
            const writable = await fileHandle.createWritable();
            await writable.write(blob);
            await writable.close();
        },
        // 核心下载方法（浏览器默认下载目录）
        async downloadPDF(url, filename) {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const blob = await response.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
            } catch (error) {
                console.error(`下载 ${filename} 失败:`, error);
                throw error;
            }
        },
        //提交--再次推送
        submitPush(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const res = await this.$http.repush(this.pushObj)
                    if (res.status == 200) {
                        this.$message.success(res.message)
                        this.init()
                        this.getDataList()
                    } else {
                        this.$message.error(res.message)
                    }
                } else {
                    this.$message.error("请完善必填项")
                    return false;
                }
            });
        },
        batchPrintPdfs(pdfUrls, index = 0) {
            if (index >= pdfUrls.length) return;

            this.printPdf(pdfUrls[index]);

            setTimeout(() => {
                this.batchPrintPdfs(pdfUrls, index + 1);
            }, 1500); // 每次打印间隔1.5秒
        },
        async printPdf(url) {
        },
        //修改备注
        submitRemark() {
            this.selectData.forEach((item, index) => {
                this.$set(item, "woamRemark", this.remark)
                if (index == this.selectData.length - 1) {
                    this.$message.success("修改成功")
                    this.remarkShow = false
                }
            })
        },
        rollback() {
            if (this.returnData.list.length == 0) {
                return this.$message.error("暂无数据")
            }
            if (this.JG_selectData.length != 1) {
                return this.$message.error("请先勾选一条数据")
            }
            var dataInfo = this.JG_selectData[0]
            this.$confirm('确定要回退该单据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await this.$http.backInvoiced({ ids: [dataInfo.aimId] })
                if (res.status == 200) {
                    this.$message.success(res.message)
                    this.init()
                    this.getDataList()
                } else {
                    this.$message.error(res.message)
                }
            }).catch(() => {
            });
        },

        async faceAuthState(actionType) {
            const res = await this.$http.faceAuthState()
            if (res.status == 200) {
                if (res.result == 'N') {
                    var arr = this.selectData.map(item => {
                        return item.billType == '' ? '普票' : item.billType
                    })
                    var list = arr.filter(item => item != arr[0])
                    if (list.length == 0 && arr[0]) {
                        this.invoiceObj.billType = arr[0]
                    } else {
                        this.invoiceObj.billType = '普票'
                    }
                    this.invoiceObj.type = 1
                    this.invoiceObj.actionType = actionType
                    if (actionType === 'returnRrRed') {
                        this.invoiceObj.rushReason = "04"
                        this.makeInvoice()
                    } else {
                        this.invoiceShow = true
                    }
                } else if (res.result == 'Y') {
                    this.$message.error("请先获取二维码,进行人脸识别!")
                }
            } else {
                if (res.message.indexOf('message') == -1) {
                    this.$message.error(res.message)
                } else {
                    this.$message.error(JSON.parse(res.message).message)

                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.makeInvoice()
                } else {
                    this.$message.error("请完善必填项")
                    return false;
                }
            });
        },
        //获取验证码
        async sendCodeClick() {
            const res = await this.$http.smsVerifyCode()
            if (res.status == 200) {
                this.codeNum = 60
                this.sendCodeNum()
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }

        },
        //倒计时
        sendCodeNum() {
            if (this.codeNum == 0) {
                this.codeNum = 60
                this.codeTitle = `重新获取验证码`
                return
            }
            setTimeout(() => {
                this.codeNum--
                this.codeTitle = `剩余${this.codeNum}秒`
                this.sendCodeNum()
            }, 1000)
        },
        async sendCodeSub() {
            if (this.formInline.sendCode == "") {
                return this.$message.error("请输入验证码")
            }
            const res = await this.$http.verifySmsCode({ ids: [this.formInline.sendCode] })
            if (res.status == 200) {
                this.formInline.sendCode = ""
                this.loginShow = false
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }
        },
        //获取二维码
        async qRCodeChange() {
            const res = await this.$http.applyInvoicingqRCode()
            if (res.status == 200) {
                this.qrCodeShow = true
                this.$nextTick(() => {
                    this.$refs.qrCodeUrl.innerHTML = "";
                    new QRCode(this.$refs.qrCodeUrl, {
                        text: res.result.ewm,
                        width: 200,
                        height: 200,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctLevel: QRCode.CorrectLevel.H
                    });
                })
                clearTimeout(this.timers)
                sessionStorage.setItem("rzid", res.result.rzid)
                this.getFaceState()
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }
        },
        async getFaceState() {
            const res = await this.$http.applyInvoicingGetFaceState({ ids: [sessionStorage.getItem("rzid")] })
            console.log(res);
            if (res.status == 200) {
                if (JSON.parse(res.result).slzt == '1') {
                    this.timers = setTimeout(() => {
                        this.getFaceState()
                    }, 3000)
                } else if (JSON.parse(res.result).slzt == '2') {
                    this.qrCodeShow = false
                    this.$message.success("识别成功")
                    clearTimeout(this.timers)
                } else if (JSON.parse(res.result).slzt == '3') {
                    this.qrCodeShow = false
                    this.$message.error("二维码过期,请重新获取")
                    clearTimeout(this.timers)
                }
            } else {
                this.qrCodeShow = false
                this.$message.error(JSON.parse(res.message).message)
                clearTimeout(this.timers)
            }
        },
        pushMethodChange(index, type) {
            if (this.returnData.list[index][type] == 0) {
                this.returnData.list[index].pushPhone = ""
                this.returnData.list[index].pushEmail = ""
            } else if (this.returnData.list[index][type] == 1) {
                this.returnData.list[index].pushEmail = ""
            } else if (this.returnData.list[index][type] == 2) {
                this.returnData.list[index].pushPhone = ""
            }
        },
        init() {
            this.returnData.detailsList = []
            this.selectDetailsData = []
            this.selectData = []
            this.JG_selectData = []
        },
        //开票
        async makeInvoice() {
            // 优化后代码：使用Map提高查找效率
            var list = [];
            // 创建detailsList的映射表，以dasdId为键
            const detailsMap = new Map();
            this.returnData.detailsList.forEach(item => {
                if (!detailsMap.has(item.dasdId)) {
                    detailsMap.set(item.dasdId, []);
                }
                detailsMap.get(item.dasdId).push(item);
            });

            // 遍历selectDetailsData，直接从Map中获取匹配项
            this.selectDetailsData.forEach(item => {
                if (detailsMap.has(item.dasdId)) {
                    list.push(...detailsMap.get(item.dasdId));
                }
            });
            var arr = this.selectData.map(item => {
                var arr1 = list.filter(val => val.dasmId == item.dasmId)
                if (arr1.length > 0) {
                    return {
                        businessId: item.businessId,
                        dasmId: item.dasmId,
                        cmId: item.cmId,
                        billType: this.invoiceObj.billType,
                        professId: item.professId,
                        detailList: arr1.map(item1 => {
                            return {
                                rowno: item1.index + 1,
                                bgpUnitmeasurement: item1.bgpUnitmeasurement,
                                bgmName: item1.bgmName,
                                spec: item1.spec,
                                businessId: item1.businessId,
                                dasdId: item1.dasdId,
                                dasmId: item.dasmId,
                                price: item1.price,
                                psprice: item1.psprice,
                                money: item1.money,
                                psmoney: item1.psmoney,
                                outRate: item1.outRate,
                                taxMoney: item1.taxAmount,
                                businessType: item1.businessType,
                                bgmId: item1.bgmId,
                                ddinCount: item1.ddinCount,
                                zeroMark: item1.zeroMark || "",
                                specialTax: item1.specialTax || "",
                                discountMark: item1.discountMark || "",
                            }
                        }),
                        poolMoney: item.totalntaxMoney,
                        poolPsmoney: item.oldMoney,
                        pushMethod: item.pushMethod,
                        pushPhone: item.pushPhone,
                        pushEmail: item.pushEmail,
                        remark: item.woamRemark || "",
                        taxMoney: item.taxMoney,
                        puBank: this.puBank || 0,
                        suBank: this.suBank || 0,
                        batchInfo: this.batchInfo || 0,
                        rushReason: this.invoiceObj.rushReason || "",
                    }
                } else {
                    return {
                        businessId: item.businessId,
                        professId: item.professId,
                        cmId: item.cmId,
                        detailList: [],
                        poolMoney: item.totalntaxMoney,
                        poolPsmoney: item.oldMoney,
                        pushMethod: item.pushMethod,
                        pushPhone: item.pushPhone,
                        pushEmail: item.pushEmail,
                        remark: item.woamRemark || "",
                        taxMoney: item.taxMoney,
                        billType: this.invoiceObj.billType,
                        puBank: this.puBank || 0,
                        suBank: this.suBank || 0,
                        batchInfo: this.batchInfo || 0,
                        rushReason: this.invoiceObj.rushReason || "",
                    }
                }
            })
            const params = {
                masterDtoList: arr,
                type: this.invoiceObj.type,
                taxSplitType: this.taxSplitType,
                isRemark: this.isRemark,
            }
            const res = this.invoiceObj.actionType === 'returnRedChong'
                ? await this.$http.returnRedChong(params)
                : this.invoiceObj.actionType === 'returnRrRed'
                    ? await this.$http.returnRrRed(params)
                    : await this.$http.addApply(params)
            if (res.status == 200) {
                this.$message.success(res.message)
                this.invoiceObj = {
                    type: 1,
                    billType: "普票",
                    rushReason: "",
                }
                this.invoiceShow = false
                this.init()
                this.getDataList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.init()
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.init()
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.init()
            this.getDataList()
        },

        // 获取数据列表
        async getDataList() {
            let responseData;
            if (this.activeName == 'first') {
                responseData = await this.$http.notInvoicedList(this.getRequestData)
            } else if (this.activeName == 'second') {
                responseData = await this.$http.queryApplyList(this.getRequestData)
            }
            if (responseData && responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.total = responseData.result.total
                this.returnData.list.forEach((item, index) => {
                    this.$set(item, 'index', index)
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        selectChange(selection, row, type) {
            console.log(selection, row, type, '11111111111111111');
            if (type == 'hz') {
                this.selectData = selection
                if (this.selectData.length == 0) {
                    return this.returnData.detailsList = []
                }
                this.getDataDetails()
            } else if (type == "mx") {
                this.selectDetailsData = selection
                var arr1 = this.selectDetailsData.map(item => {
                    if (item.ddinCount == 0) {
                        return item.dasdId
                    }
                })
                this.returnData.detailsList.forEach(item => {
                    if (arr1.filter(val => val == item.dasdId).length > 0) {
                        this.$set(item, 'ddinCount', item.invoicableQuantity)
                    }
                })
                const dasmIdSet = new Set(this.selectDetailsData.map(item => item.dasmId));
                this.selectData = [];
                this.$refs.hzTable.clearSelection()
                if (dasmIdSet.size > 0) {
                    this.returnData.list.forEach(item => {
                        if (dasmIdSet.has(item.dasmId)) {
                            this.selectData.push(item);
                        }
                    });
                }
                this.$nextTick(() => {
                    this.selectData.forEach(item => {
                        this.$refs.hzTable.toggleRowSelection([
                            {
                                row: item,
                                selected: true
                            }
                        ])
                    })
                })
            }
        },
        selectChangeAll(selection, type) {
            if (type == 'hz') {
                this.selectData = selection
                if (this.selectData.length == 0) {
                    return this.returnData.detailsList = []
                }
                this.getDataDetails()
            } else if (type == "mx") {
                this.selectDetailsData = selection
                if (this.selectDetailsData.length == 0) {
                    this.$nextTick(() => {
                        this.selectData = []
                        this.$refs.hzTable.clearSelection()
                    })
                }
                // 去重后的 dasmId 集合
                const dasmIdSet = new Set(this.selectDetailsData.map(item => item.dasmId));
                this.selectData = [];
                if (dasmIdSet.size > 0) {
                    this.returnData.list.forEach(item => {
                        if (dasmIdSet.has(item.dasmId)) {
                            this.selectData.push(item);
                        }
                    });
                }
                this.$nextTick(() => {
                    this.selectData.forEach(item => {
                        this.$refs.hzTable.toggleRowSelection([
                            {
                                row: item,
                                selected: true
                            }
                        ])
                    })
                })
                var arr1 = this.selectDetailsData.map(item => {
                    if (item.ddinCount == 0) {
                        return item.dasdId
                    }
                })
                this.returnData.detailsList.forEach(item => {
                    if (arr1.filter(val => val == item.dasdId).length > 0) {
                        this.$set(item, 'ddinCount', item.invoicableQuantity)
                    }
                })
            }
        },
        async getDataDetails() {
            let responseData;
            if (this.activeName == 'first') {
                responseData = await this.$http.sudoDetail({ ids: this.selectData.map(item => item.dasmId) })
            } else if (this.activeName == 'second') {
                responseData = await this.$http.queryApplyDetailList({ ids: this.JG_selectData.map(item => item.aimId) })
            }
            if (responseData && responseData.status == 200) {
                this.returnData.detailsList = responseData.result
                this.returnData.detailsList.forEach((item, index) => {
                    if (this.activeName == 'first') {
                        this.$set(item, 'ddinCount', item.invoicableQuantity)
                        this.$set(item, 'psmoney', this.$common.getDecimalInfo(3, NP.times(item.ddinCount || 0, item.psprice)))
                        var money = item.psmoney == 0 || item.psmoney == "" ? 0 : NP.divide(item.psmoney, NP.plus(NP.divide(item.outRate, 100), 1))
                        this.$set(item, 'money', this.$common.getDecimalInfo(3, money))
                        this.$set(item, 'taxAmount', this.$common.getDecimalInfo(3, NP.minus(item.psmoney, item.money)))
                    }
                    this.$set(item, 'index', index)
                })
                this.$nextTick(() => {
                    this.returnData.detailsList.forEach((item, index) => {
                        this.$refs.mxTable.toggleRowSelection([
                            {
                                row: item,
                                selected: true
                            }
                        ])
                    })
                    this.selectDetailsData = JSON.parse(JSON.stringify(this.returnData.detailsList))
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        //获取状态
        getIsGsp(str, val) {
            var arr = str.filter(item => item.value == val)
            if (arr.length > 0) {
                return arr[0].key
            } else {
                return ""
            }
        },
    },
    created() {
        var ormList = JSON.parse(sessionStorage.getItem('ormList'))
        if (ormList.invoiceDefault == 1) {
            this.puBank = 1
        }
        if (ormList.invoiceSaleinfo == 1) {
            this.suBank = 1
        }
        if (ormList.invoiceBatch == 1) {
            this.batchInfo = 1
        }
        if (ormList.splitTax == 1) {
            this.taxSplitType = 1
        }
        if (ormList.invoiceRemark == 1) {
            this.isRemark = 1
        }
        this.getPageInfo('first')
    },
    destroyed() {
        clearTimeout(this.timers)
    },
    updated() {
        console.log(this.$common.getTableHeight());

        this.tableHeight = this.$common.getTableHeight() - 40
    }, //生命周期 - 更新之后
}
</script>

<style scoped>
.loginShow >>> .el-input-group__append {
    color: #fff !important;
    background-color: #409eff !important;
}
.qrcode_div {
    text-align: center;
    width: 230px;
    height: 290px;
    background-color: #fff;
    border: 1px solid #b2b2b2;
}
.qrcode_div .title {
    font-size: 18px;
    padding: 10px;
    color: #000;
    font-weight: bold;
}
#qrcode {
    width: 200px;
    height: 200px;
    margin: 0 auto;
}
.copy {
    color: #409eff;
    cursor: pointer;
}
.div_button {
    display: flex;
    align-items: center;
    margin-left: 20px;
    color: #000;
}
.tag {
    position: absolute;
    right: 90px;
}
</style>